import React from 'react';

export default ({name}) => <span className={`icon ion-${name}`}></span>;
